export default __webpack_public_path__ + "static/s6-c960ad2d635d8247e2590815d43ff1f8.webp";